import React from "react"

import { PortfolioPageObj } from "scrivito/Objs/PortfolioPage/PortfolioPageObjClass"
import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { ProductCategoryObj } from "scrivito/Objs/ProductCategory/ProductCategoryObjClass"
import { SelectOption } from "shared/types/Select"

import { ProductFilterFormData } from "entities/products/types/ProductFilter"

import { PortfolioProductSelectView } from "./PortfolioProductSelectView"
import { usePortfolioProductSelectViewModel } from "./model/usePortfolioProductSelectViewModel"

export interface PortfolioProductSelectModel {
  portfolio: PortfolioPageObj | undefined
  productCategories: ProductCategoryObj[] | undefined
  products: ProductObj[] | undefined

  productGroupOptions: SelectOption<string>[] | undefined

  filter: ProductFilterFormData

  onProductSelect: (productType: string) => void
  onProductFilterChange: (formData: ProductFilterFormData) => void
  onProductCategorySelect: (productCategory: ProductCategoryObj | null) => void
}

export interface PortfolioProductSelectProps
  extends PortfolioProductSelectModel {}

export const PortfolioProductSelect = React.memo(
  (props: PortfolioProductSelectProps) => {
    return (
      <PortfolioProductSelectView
        {...usePortfolioProductSelectViewModel(props)}
      />
    )
  }
)
